import { render, staticRenderFns } from "./apply-add.html?vue&type=template&id=98fbb22e&"
import script from "./apply-add.ts?vue&type=script&lang=ts&"
export * from "./apply-add.ts?vue&type=script&lang=ts&"
import style0 from "./apply-add.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports